import React, { useState } from "react";
const AuthServiceBanner = () => {
    const [dismissed, setDismissed] = useState(false);
    if (dismissed)
        return null;
    return (React.createElement("div", { className: "auth-service-banner", role: "status" },
        React.createElement("span", { className: "auth-service-banner-text" },
            "Couldn't reach the sign-in service \u2014 it looks like it's being blocked by your network (common on corporate or school Wi-Fi). You can keep browsing your saved data, but signing in and syncing won't work until your IT team allows access to the authentication provider (Clerk \u2014 ",
            React.createElement("strong", null, "*.clerk.com"),
            " and",
            ' ',
            React.createElement("strong", null, "*.clerk.accounts.dev"),
            ")."),
        React.createElement("button", { className: "auth-service-banner-dismiss", onClick: () => setDismissed(true), "aria-label": "Dismiss banner" }, "\u00D7")));
};
export default AuthServiceBanner;
